import { LoadingDialog } from '@/components/controls';
import { useBrief, useBriefs, useDeleteBrief, useUpsertBrief } from '@/hooks';
import { Add as AddIcon } from '@mui/icons-material';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useSearchParams } from 'react-router';
import { BriefConfigurationDialog } from './BriefConfigurationDialog';
import { BriefCover } from './BriefCover';

const DEFAULT_BRIEF = {
  title: '',
  groupCodes: [],
  excludedSections: [],
};

export function Briefs() {
  const {
    query: { data: briefs },
  } = useBriefs();
  const { mutate: upsertBrief } = useUpsertBrief();
  const { mutate: deleteBrief } = useDeleteBrief();
  const [searchParams, setSearchParams] = useSearchParams();
  const code = searchParams.get('configure');
  const {
    query: { data: fetchedBrief },
  } = useBrief(code);
  const brief = code === 'new' ? DEFAULT_BRIEF : fetchedBrief;

  function handleAddClick() {
    setSearchParams({ configure: 'new' });
  }

  function handleClose(values) {
    if (values) {
      upsertBrief(values);
    }

    setSearchParams();
  }

  function handleDelete() {
    deleteBrief(code);

    setSearchParams();
  }

  return (
    <Box sx={{ flexGrow: 1, padding: 2 }}>
      <title>IR3 | Briefs</title>
      <Typography variant="h5" gutterBottom>
        My Briefs
      </Typography>
      <Grid container spacing={2}>
        {briefs.map((brief) => (
          <Grid key={brief.code}>
            <BriefCover brief={brief} />
          </Grid>
        ))}
        <Grid>
          <Button
            variant="outlined"
            sx={{
              width: 180,
              height: 226,
              color: 'text.secondary',
              borderColor: 'text.secondary',
              borderStyle: 'dashed',
              '&:hover': { color: 'primary.main' },
            }}
            endIcon={<AddIcon />}
            onClick={handleAddClick}
          >
            Add
          </Button>
        </Grid>
      </Grid>
      {brief ? (
        <BriefConfigurationDialog
          brief={brief}
          isOpen={Boolean(code)}
          onClose={handleClose}
          onDelete={handleDelete}
        />
      ) : (
        <LoadingDialog isOpen={Boolean(code)} />
      )}
    </Box>
  );
}
